import { Status } from "@app/components";
import type { RootState } from "@app/redux";
import { type FormatNumberOptions, formatNumber } from "@app/utils";
import React from "react";
import { useSelector } from "react-redux";
import messages from "./messages";
import type { Properties } from "./properties";
import "./trade-status-card.css";

const TradeStatusCardView = React.memo((props: Properties) => {
	const { language } = useSelector(
		(rootState: RootState) => rootState.language,
	);

	const getFiguresContent = () => {
		const currencyOptions: FormatNumberOptions = {
			currencyCode: messages[language].currencyCode,
			decimalPlaces: props.isDesktop ? 2 : 0,
			groupSeparator: messages[language].groupSeparator,
		};

		return (
			<>
				<div className={rowStyle}>
					<div className={figureStyle}>{messages[language].investedAmount}</div>
					<div className={figureStyle}>
						{props.investedAmount > 0
							? formatNumber(props.investedAmount, currencyOptions)
							: messages[language].defaultValue}
					</div>
				</div>
				<div className={rowStyle}>
					<div className={figureStyle}>{messages[language].netProfit}</div>
					<div className={figureStyle}>
						{props.netProfit > 0
							? formatNumber(props.netProfit, currencyOptions)
							: messages[language].defaultValue}
					</div>
				</div>
			</>
		);
	};

	const colStyle = ["flex", "flex-col", "mt-7", "trade-status-text"].join(" ");

	const figureStyle = [
		"font-primary-medium",
		"lg:mb-2",
		"text-sm",
		"trade-status-text",
	].join(" ");

	const headingStyle = [
		"font-primary-bold",
		"trade-status-text",
		"trade-status-heading",
		"leading-none",
	].join(" ");

	const mainStyle = [
		"px-5",
		"lg:px-7",
		"pb-4",
		"lg:py-8",
		"trade-status",
		props.className,
	].join(" ");

	const subheadingStyle = [
		"font-primary-light",
		"flex",
		"items-center",
		"justify-center",
		"text-sm",
		"lg:text-lg",
		"trade-status-text",
		"trade-status-subheading",
	].join(" ");

	const rowStyle = ["flex flex-row justify-between"].join(" ");

	const statusBlockStyle = "h-10 trade-status-block";

	return (
		<div className={mainStyle}>
			<div className={headingStyle}>
				{props.isDesktop
					? messages[language].headingDesktop
					: messages[language].heading}
			</div>
			<div className={subheadingStyle}>{props.status}</div>
			<div className={rowStyle}>
				<Status
					className={statusBlockStyle}
					type="bar"
					stage={props.stage}
					totalStages={3}
				/>
			</div>
			<div className={colStyle}>{getFiguresContent()}</div>
		</div>
	);
});

export { TradeStatusCardView };
